import { styled, useTheme } from '@mui/material';
import { Typography } from '../../../components/Typography/Typography';
import {
  getGovernanceScoreIcon,
  getGovernanceScoreLabel,
} from '../../../utils/governanceScoreUtils';

const Wrapper = styled('div')`
  display: flex;
  align-items: center;
  gap: 8px;
`;

interface Props {
  governanceScore?: number | null;
}

export const GovernanceScore = ({ governanceScore }: Props) => {
  const { colors } = useTheme();

  const label = getGovernanceScoreLabel(governanceScore);

  const Icon = getGovernanceScoreIcon(governanceScore);

  return (
    <Wrapper>
      <Icon />
      <Typography variant='h3' color={colors.primary[90]}>
        {label}
      </Typography>
    </Wrapper>
  );
};
